import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import { PostSimple } from '../model/wordpress.model';

@Injectable()
export class WordpressService {

    moreUrl = API.WORDPRESS.MORE

    constructor(
        private http: HttpClient,
    ) { }

    getPostList() {
        return this.http.get<PostSimple[]>(API.WORDPRESS.POST_LIST)
    }


}
